import { useContext } from 'react';

import { XYChartVisibleAxesConfigContext } from '../context/axes/XYChartVisibleAxesConfig.context.js';

export const useVisibleAxesConfig = () => {
  const context = useContext(XYChartVisibleAxesConfigContext);

  if (context === undefined) {
    throw new Error(
      'useVisibleAxesConfig must be used within a XYChartVisibleAxesConfigContext',
    );
  }

  return context;
};
